/* import __COLOCATED_TEMPLATE__ from './admin-note-created.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();